<template>
    <div class="login">
        <div class="login-all-body">
            <div class="login-content">
                <div class="login-header">蜂电科技智能设备管理系统</div>
                <div class="login-body">
                    <div class="login-body-input">
                        <el-input class="login-input" placeholder="请输入账号" v-model="account" clearable></el-input>
                        <el-input class="login-input" placeholder="请输入密码" v-model="password" type="password" clearable @keyup.enter.native="login()"></el-input>
                        <el-checkbox v-model="checked" class="remember-pass">记住密码</el-checkbox>
                    </div>
                </div>
                <div class="login-button-div">
                    <el-button class="login-button" type="primary" @click="login">登 录</el-button>
                </div>
                <div class="login-bottom-btn">
                    <div @click="dialogFormVisible1 = true">注册账号</div>
                    <div @click="dialogFormVisible2 = true ">忘记密码</div>
                </div>
            </div>

            <el-dialog title="注册账号" width="5rem" :visible.sync="dialogFormVisible1">
                <el-form>
                    <el-form-item label="账号：" label-width="72px">
                        <el-input v-model="ver_userid" autocomplete="off" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label-width="72px">
                        <el-button class="login-button" type="primary" @click="Register_Verification">获取图片验证码
                        </el-button>
                    </el-form-item>
                    <el-form-item label-width="72px">
                        <img :src="ver_picture" @click="Register_Verification">
                    </el-form-item>
                    <el-form-item label="验证码：" label-width="72px">
                        <el-input v-model="ver_code" autocomplete="off" placeholder="请输入图片验证码"
                                  class="ver_code"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱：" label-width="72px">
                        <el-input v-model="ver_email" autocomplete="off" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="密码：" label-width="72px">
                        <el-input v-model="ver_pwd" autocomplete="off" placeholder="请输入密码"></el-input>
                        <br/>
                        <span style="font-size:10px">以字母开头，长度在6~18之间，只能包含字符、数字和下划线</span>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                    <el-button type="primary" @click="Register">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="忘记密码" width="5rem" :visible.sync="dialogFormVisible2">
                <el-form>
                    <!--<el-form-item label="账号：" label-width="72px">-->
                    <!--<el-input v-model="for_userid" autocomplete="off" placeholder="请输入账号"></el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item label="手机号：" label-width="72px">
                        <el-input v-model="for_phone" autocomplete="off" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label-width="70px">
                        <el-button :disabled="isdisabled" type="primary" @click="Forget_pass()">{{minute_down}}
                        </el-button>
                    </el-form-item>
                    <el-form-item label="验证码：" label-width="72px">
                        <el-input v-model="for_code" autocomplete="off" placeholder="请输入手机验证码" class=""></el-input>
                    </el-form-item>
                    <el-form-item label="新密码：" label-width="72px">
                        <el-input v-model="new_pass" autocomplete="off" placeholder="请输入新密码" class=""></el-input>
                        <br/>
                        <span style="font-size:10px">以字母开头，长度在6~18之间，只能包含字符、数字和下划线</span>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                    <el-button type="primary" @click="Set_newpass()">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import store from "../store";

    export default {
        name: "login",
        data() {
            return {
                account: '',
                password: '',
                checked:false,

                dialogFormVisible1: false,
                dialogFormVisible2: false,

                ver_userid: '',
                ver_vid: '',
                ver_picture: '',
                ver_code: '',
                ver_pwd: '',
                ver_email: '',

                for_userid: '',
                for_phone: '',
                for_code: '',
                minute_down: "获取验证码",
                new_pass: '',
                countdown: 60,
                isdisabled: false,

            }
        },
        mounted() {
            if(document.body.clientWidth<800){
                this.$router.push('./onlyPC')
            }
            this.account = window.localStorage.userid;
            this.password = window.localStorage.password;
            this.checked = JSON.parse(window.localStorage.checked);
        },
        methods: {
            login() {
                this.$http.get(`${store.state.url}user/login/${this.account}/${this.password}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            window.localStorage.uid = res.Data.Uuid;
                            window.localStorage.token = res.Expand;
                            window.localStorage.userid = res.Data.Userid;
                            window.localStorage.nick = res.Data.Nick;
                            window.localStorage.avatarpath = res.Data.Avatarpath;
                            window.localStorage.price = res.Data.Price;
                            window.localStorage.sid = '';
                            window.localStorage.devid = '';
                            store.commit('assigntreeZoneid', '');

                            if(this.checked==true){
                                window.localStorage.password=res.Data.Pass;
                                window.localStorage.checked=true;
                            }else{
                                window.localStorage.password='';
                                window.localStorage.checked=false;
                            }

                            if (res.Data.Param != undefined) {
                                if (res.Data.Param.excess != undefined) {
                                    window.localStorage.excess = res.Data.Param.excess;
                                } else {
                                    window.localStorage.excess = 0;
                                }
                                if (res.Data.Param.alarmvalue != undefined) {
                                    window.localStorage.alarmvalue = res.Data.Param.alarmvalue;
                                } else {
                                    window.localStorage.alarmvalue = 0;
                                }
                                if (res.Data.Param.sms != undefined) {
                                    window.localStorage.sms = res.Data.Param.sms;
                                } else {
                                    window.localStorage.sms = 1;
                                }
                            }

                            this.$http.get(`${store.state.url}zone/afterlogin?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                                .then((res) => {
                                    if (res.Code == 0) {
                                        if (res.Data == true) {
                                            window.localStorage.isChild = 1;
                                            this.$router.push('/home');
                                        } else {
                                            window.localStorage.isChild = 0;
                                            this.$router.push('/home');
                                        }
                                    } else {
                                        this.$message(res.Message);
                                    }
                                })
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },

            //注册新账号获取验证码
            Register_Verification() {
                if (this.ver_userid == '') {
                    this.$message("请先输入手机号！");
                } else {
                    this.$http.get(`${store.state.url}user/check/` + this.ver_userid + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.ver_vid = res.Data;
                                this.ver_picture = `${store.state.url}user/verifycode/` + res.Data + `?uid=&token=`;
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }
            },

            //注册账号
            Register() {
                let password = /^[a-zA-Z]\w{5,17}$/;
                let email = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
                if (password.test(this.ver_pwd)) {
                    if (email.test(this.ver_email)) {
                        this.$http({
                            method: 'post',
                            url: `${store.state.url}user`,
                            headers: {
                                pid: '',
                                vid: this.ver_vid,
                                code: this.ver_code,
                            },
                            data: {
                                userid: this.ver_userid,
                                phone: this.ver_userid,
                                pass: this.ver_pwd,
                                email: this.ver_email,
                            },
                            dataType: "json",
                        })
                            .then((res) => {
                                if (res.Code == 0) {
                                    this.$message('注册成功！');
                                    this.dialogFormVisible1 = false;
                                    this.ver_userid = '';
                                    this.ver_vid = '';
                                    this.ver_picture = '';
                                    this.ver_code = '';
                                    this.ver_pwd = '';
                                    this.ver_email = '';
                                } else if (res.Code == 1002) {
                                    this.$message(res.Message);
                                    this.ver_code = '';
                                    this.Register_Verification();
                                } else {
                                    this.$message(res.Message);
                                }
                            })
                    } else {
                        this.$message("邮箱格式不正确，请重新填写！");
                        this.ver_email = '';
                    }
                } else {
                    this.$message("密码格式不正确，请更换密码！");
                    this.ver_pwd = '';
                }
            },

            //忘记密码
            Forget_pass() {
                if (this.for_userid == '' || this.for_phone == '') {
                    this.$message("请输入账号和手机号！");
                } else {
                    this.$http.get(`${store.state.url}user/forgetpass/` + this.for_userid + `/` + this.for_phone + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.$message(res.Message);
                                this.settime();
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }
            },

            //设置新密码
            Set_newpass() {
                let password = /^[a-zA-Z]\w{5,17}$/;
                if (password.test(this.new_pass)) {
                    this.$http.put(`${store.state.url}user/forgetpass/` + this.for_userid + `/` + this.new_pass + `/` + this.for_code + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.$message("设置新密码成功！");
                                this.dialogFormVisible2 = false;
                            } else {
                                this.$message(res.Message);
                            }
                        })
                } else {
                    this.$message("密码格式不正确，请更换密码！");
                }
            },

            //倒计时60s
            settime() {
                if (this.countdown == 0) {
                    console.log(this.countdown)
                    this.minute_down = "重新发送验证码";
                    this.countdown = 60;
                    this.isdisabled = false;
                } else {
                    console.log(this.countdown)
                    this.minute_down = "重新发送(" + this.countdown + "s)";
                    this.countdown--;
                    this.isdisabled = true;
                    setTimeout(() => {
                        this.settime();
                    }, 1000)
                }
            },


        }
    }
</script>

<style scoped>
    .login {
        width:100%;
        height:100%;
        background-image: url(../assets/login_background.jpg);
        background-repeat:no-repeat;
        background-size: 100% 100%;
    }

    .login-all-body {
        padding-top: 13%;
        display: flex;
        justify-content: center;
    }

    .login-content {
        width: 4rem;
        /*background-color: rgba(47, 47, 47, 0.38);*/
        background-color: rgba(177, 177, 177, 0.35);
        box-shadow:0 0 50px rgba(172, 172, 172, 0.47);
    }

    .login-header {
        padding-top: 0.3rem;
        display: flex;
        justify-content: center;
        margin-bottom: 0.4rem;
        font-size: 0.25rem;
        color:white;
    }

    .login-body {
        display: flex;
        justify-content: center;
    }

    .login-body-input {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .login-input {
        margin-bottom: 0.3rem;
        width: 3.5rem;
    }
    .remember-pass {
        margin-top:-0.2rem;
        margin-bottom:0.1rem;
        color:#ffffff;
    }

    .login-button-div {
        display: flex;
        justify-content: center;
        padding-bottom: 0.2rem;
    }

    .login-button {
        display: flex;
        justify-content: center;
        width: 3.5rem;
    }

    .login-bottom-btn {
        display: flex;
        justify-content: center;
    }

    .login-bottom-btn div{
        font-size:14px;
        color:white;
        margin: 0 0.5rem 0.2rem 0.5rem;
    }
    .login-bottom-btn div:hover{
        text-decoration:underline;
        color:#409EFF;
        cursor:pointer;
    }

    .el-form-item__content .el-input {
        width: 90%;
    }

    .el-form-item__content .el-button {
        width: 90%;
    }

    .el-form-item__content span {
        width: 80%;
    }

    .el-form-item .el-form-item__label {
        padding: 0 !important;
    }

    .ver_code {
        width: 60%;
    }

    .el-dialog__body {
        height: 5rem !important;
    }
</style>
